import { Phone } from "lucide-react";
import { business } from "@/data/content";

export default function MobileCTABar({ onQuote }) {
  return (
    <div
      data-testid="mobile-cta-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-t border-pristine-aqua px-3 py-2.5 flex gap-3 shadow-[0_-4px_24px_rgba(15,58,112,0.08)]"
    >
      <a
        href={business.phoneHref}
        data-testid="mobile-bar-call"
        className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full border-2 border-pristine-blue text-pristine-blue font-semibold"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <button
        onClick={onQuote}
        data-testid="mobile-bar-quote"
        className="flex-1 inline-flex items-center justify-center h-12 rounded-full bg-pristine-blue text-white font-semibold"
      >
        Request Quote
      </button>
    </div>
  );
}
